import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useParams, withRouter, useLocation } from 'react-router-dom';
import { Swiper, Button } from 'antd-mobile-v5';
import { Modal, Toast } from 'antd-mobile';
import styles from './home.module.scss';
import fangzhicuzhong from '../../static/images/fangzhicuzhong.png';
import icon_more from '../../static/images_doctor/icon_more.png';
import tool0 from '../../static/images_doctor/tool0.png';
import NeedLoginRegister from '../../static/images_doctor/need_login_register.png';
import NeedAddProject from '../../static/images_doctor/need_add_project.png';
import case_green from '../../static/images_doctor/case_green.svg';
import case_purple from '../../static/images_doctor/case_purple.svg';
import case_yellow from '../../static/images_doctor/case_yellow.svg';
import question_green from '../../static/images_doctor/question_green.svg';
import question_purple from '../../static/images_doctor/question_purple.svg';
import question_yellow from '../../static/images_doctor/question_yellow.svg';
import research_green from '../../static/images_doctor/research_green.svg';
import research_purple from '../../static/images_doctor/research_purple.svg';
import research_yellow from '../../static/images_doctor/research_yellow.svg';
import video_green from '../../static/images_doctor/video_green.svg';
import video_purple from '../../static/images_doctor/video_purple.svg';
import video_yellow from '../../static/images_doctor/video_yellow.svg';
import { SwiperRef } from 'antd-mobile-v5/es/components/swiper';
import { ApiCore } from '../../api/index';
import Notice from './notice';
import ActivitySkeleton from './activitySkeleton';
import ScaleSkeleton from './scaleSkeleton';
import ProjectSkeleton from './projectSkeleton';
import { Tabs, List, ListView, PullToRefresh } from 'antd-mobile';
import utils from '../../utils/utils';
import icon_green_search from '../../static/images_doctor/tool_introdce_search.png';
import introduce_tool_no_content from '../../static/images_doctor/introduce_tool_no_content.png';
import introduce_tools_search_no_result from '../../static/images_doctor/introduce_tools_search_no_result.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';

const api = new ApiCore();

let env = process.env.REACT_APP_ENV;

let delayExcute: any = null;

const tabs = [
    { title: '最新' },
    { title: '量表工具' },
    { title: '决策树' },
    { title: '' },
    { title: '' }
];

function Home(props: any) {
    let routeParams = sessionStorage.getItem("activityType")

    const [loadingReady, setLoadingReady] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [mergeProjects, setmMergeProjects] = useState<any>([]);
    const [imgList, setImgList] = useState<any>([]);
    const [scaleList, setScaleList] = useState([]);
    const [activityDataReady, setActivityDataReady] = useState(false);
    const [scaleDataReady, setScaleDataReady] = useState(false);
    const [introduceToolsReady, setIntroduceToolsReady] = useState(false);
    const [projectDataReady, setProjectDataReady] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [tenantCode, setTenantCode] = useState('');
    const ref = useRef<SwiperRef>(null);
    const [isWxMiniLogin, setIsWxMiniLogin] = useState(false);
    const [searchTitle, setSearchTitle] = useState<any>(null);
    const [scaleIntroduceList, setScaleIntroduceList] = useState<any>([]);
    const [currentScaleIntroduceList, setCurrentScaleIntroduceList] = useState<any>([]);
    const [initScaleIntroduceNum, setInitScaleIntroduceNum] = useState<any>(3);
    const [introduceToolTabs, setIntroduceToolTabs] = useState<any>([]);
    const [currentIntroToolTab, setCurrentIntroToolTab] = useState<any>({});
    const [renderList, setRenderList] = useState<any>([]);
    // 上拉加载与下拉刷新
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false); // 下拉刷新状态
    const [isMore, setIsMore] = useState<boolean>(true); // 是否还有更多数据
    const [curPage, setCurPage] = useState<number>(1); // 当前加载的页数
    const [curPageSize, setCurPageSize] = useState<number>(10); // 分页条数
    const [total, setTotal] = useState<number>(10); // 总条数
    const [listReady, setListReady] = useState(false);
    const [listLoading, setListLoading] = useState(false);
    // 设置加载状态
    const [loading, setLoading] = useState<any>(null);
    // 是否加载更多
    const [isLoadingMore, setIsLoadingMore] = useState(true);
    const [tabPage, setTabPage] = useState(0);

    useEffect(() => {
        document.title = '首页';

        //本地存储医生工作室量表颜色主题和跳转路由时的来源
        localStorage.setItem('scaleTheme', 'blue')
        localStorage.setItem('source', 'doctor')

        if (window.location.search) {
            let search = window.location.search
            let url = window.location.href.replace(window.location.search, '') + search
            window.location.replace(url)
        } else {
            initData();
            initCondition();
        }

        return () => {
        }
    }, [])

    const initCondition = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        if (savedUrlParam) {
            let savedOriginUrlParam: any = {};
            try {
                savedOriginUrlParam = JSON.parse(savedUrlParam);
            } catch (error) {
                savedOriginUrlParam = {};
            }
            // 返回至小程序授权、游客登录页
            let _from = savedOriginUrlParam.from;
            if (_from && (_from === 'login' || _from === 'tenant' || _from === 'authGuestIndex')) {
                if (utils.isMiniProgram()) {
                    setIsWxMiniLogin(true);
                }
            }
        }
    };

    // 初始化数据，数据合并处理
    const initData = () => {
        sessionStorage.removeItem('Home_Title');
        let userInfo = sessionStorage.getItem('token');
        let mUser: any = {};
        let tenantCode = '';
        let urlParams = utils.getUrlParams() || {};
        if (urlParams.tenantCode) {
            tenantCode = urlParams.tenantCode;
        }
        if (userInfo) {
            try {
                mUser = JSON.parse(userInfo)
            } catch (error) {
                mUser = {};
            };
            if (mUser.token) {
                setIsLogin(true);
            }
            if (!urlParams.tenantCode) {
                tenantCode = mUser.tenantCode || '';
            }
        }
        // begin 暂未用到，有需求变更用到属性会用到
        let activityScaleData = null;
        let projectData = null;
        let activityScaleReady = false;
        let projectReady = false;
        // end
        setActivityDataReady(false);
        setScaleDataReady(false);
        setProjectDataReady(false);
        setIntroduceToolsReady(false);
        // 获取活动轮播与工具数据
        api.getDoctorHomePage(tenantCode).then((res: any) => {
            if (res.code == 0) {
                activityScaleData = res.data;
                renderData(res);
                activityScaleReady = true;
                setActivityDataReady(true);
                setScaleDataReady(true);
                setIntroduceToolsReady(true);
            }
        });
        // 获取我的项目数据
        api.getDoctorHomeData({
            tenantCode: tenantCode,
            types: ['Project'],
        }).then((res: any) => {
            
            if (res.code == 0) {
                projectData = res.data;
                if (res.data && res.data[0] && res.data[0].value) {
                    let projectKeywordList = res.data[0].value
                    let _projectList: any = [];
                    const keyword = routeParams === 'TYGJ' ? '同医共济' : routeParams === 'FZCZ' ? '防治卒中' : '';
                    if(keyword) {
                        _projectList = projectKeywordList.filter((item: any) => item.name.includes(keyword));
                    } else {
                        _projectList = projectKeywordList.filter((item: any) => !item.name.includes("同医共济") && !item.name.includes("防治卒中"))
                    }
                    setProjectList(_projectList);
                    let _mergeProjects = [];
                    for (let i = 0; i < _projectList.length; i += 2) {
                        _mergeProjects.push(_projectList.slice(i, (i + 2)));
                    }
                    setmMergeProjects(_mergeProjects);
                }
                projectReady = true;
                setProjectDataReady(true);
            }
        });
    }

    // 获取属性与渲染数据
    const renderData = (res: any) => {
        if (res.code == 0 && res.data) {
            let _content = res.data.content;
            if (_content) {
                let _contentDetail: any = {};
                try {
                    _contentDetail = JSON.parse(_content)
                } catch (error) {
                    _contentDetail = {};
                }
                let _contentInfo = _contentDetail;
                if (_contentInfo) {
                    if (_contentInfo.title) {
                        sessionStorage.setItem('Home_Title', _contentInfo.title);
                        document.title = _contentInfo.title;
                    }
                    (_contentInfo.modules || []).forEach((element: any) => {
                        if (res.data.values && res.data.values[element.type] && res.data.values[element.type].value) {
                            let _list = res.data.values[element.type].value;
                            _list.attributes = element.attributes;
                            if (element.type === 'Activity') {
                                let tygj = [
                                    {logo: 'https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image-test/upload_to_oss_component/edc/data/image-test//zgctt.png', name: '同医共济', path: '/collaborative?collaborativeCode=TYGJ000001&activityCode=TYGJ'}
                                ]
                                let clxs = [
                                    {logo: 'https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/active/kv/002.png', name: '卒力新生', path: '/collaborative?collaborativeCode=CG000001&activityCode=CZDJK'}
                                ]
                                let fzcz = [
                                    {logo: fangzhicuzhong, name: '防治卒中', path: '/collaborative?collaborativeCode=CG000001&activityCode=FZCZ'}
                                ]
                                if (routeParams === 'TYGJ'){
                                    _list = tygj
                                } else if (routeParams === 'CLXS'){
                                    _list = clxs
                                } else {
                                    _list = fzcz
                                }
                                setImgList(_list);
                            } else if (element.type === 'Scale') {
                                setScaleList(_list);
                            } else if (element.type === 'ScaleIntroduce') {
                                setScaleIntroduceList(_list);
                                setCurrentScaleIntroduceList(_list.page.rows);
                                setInitScaleIntroduceNum((_list.page.rows || []).length || 3);
                                const _isMore = (_list.page.total > 5);
                                setIsMore(_isMore);
                                const _tabs = _list.navs.map((item: any) => {
                                    return {
                                        ...item,
                                        title: item.name,
                                    }
                                });
                                let _PlaceHolder = [{
                                    title: ''
                                }, {
                                    title: ''
                                }]
                                const __tabs = _tabs.concat(_PlaceHolder);
                                setIntroduceToolTabs(__tabs);
                            }
                        }
                    });
                    setRenderList(_contentInfo.modules);
                }
            }
        }
    }

    // 获取对应颜色图片
    const getDisplayPicture = (type: string, index: number) => {
        let targetIcon = '';
        let remainder = index % 3;
        if (type === 'LISTEDSTYDY') {
            // 上市后研究
            if (remainder === 0) {
                targetIcon = research_green;
            } else if (remainder === 1) {
                targetIcon = research_purple;
            } else if (remainder === 2) {
                targetIcon = research_yellow;
            }
        } else if (type === 'VIDEOSOLICIT') {
            // 视频征集
            if (remainder === 0) {
                targetIcon = video_green;
            } else if (remainder === 1) {
                targetIcon = video_purple;
            } else if (remainder === 2) {
                targetIcon = video_yellow;
            }
        } else if (type === 'QUESTIONSURVEY') {
            // 问卷调研
            if (remainder === 0) {
                targetIcon = question_green;
            } else if (remainder === 1) {
                targetIcon = question_purple;
            } else if (remainder === 2) {
                targetIcon = question_yellow;
            }
        } else if (type === 'CASESOLICIT') {
            // 病例征集
            if (remainder === 0) {
                targetIcon = case_green;
            } else if (remainder === 1) {
                targetIcon = case_purple;
            } else if (remainder === 2) {
                targetIcon = case_yellow;
            }
        } else if (type === 'COURSESOLICIT') {
            // 课程征集
            if (remainder === 0) {
                targetIcon = case_green;
            } else if (remainder === 1) {
                targetIcon = case_purple;
            } else if (remainder === 2) {
                targetIcon = case_yellow;
            }
        }
        return targetIcon;
    }

    // 轮播条目展示
    const items = imgList.map((val: any, index: number) => (
        <Swiper.Item
            key={index}>
            <div
                className={styles.content}
                onClick={() => { loopImgToLink(val) }}
            >
                <img src={val.logo} alt="" />
            </div>
        </Swiper.Item>
    ))

    // 跳转
    const loopImgToLink = (item: any) => {
        let toUrl = item.path;
        if (toUrl.indexOf('?') >= 0) {
            toUrl += `&fromEdcDoctorHome=1`;
        } else {
            toUrl += `?fromEdcDoctorHome=1`;
        }
        props.history.push(toUrl);
    }

    // 跳转工具页
    const toTool = (val: any) => {
        // if (env === 'development' || env === 'test') {
        //     window.location.href = `https://risingstar-test.huimeimt.com/evaluation/${val.scaleCode}`;
        // } else if (env === 'production') {
        //     window.location.href = `https://scale-saas.huimeihealth.com.cn/evaluation/${val.scaleCode}`
        // }
        if (val.scaleCode.includes('DRUG') || val.scaleCode.includes('TNM')) {
            props.history.push(`/scale/aggregationScale/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        } else {
            props.history.push(`/scale/evaluation/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        }
    }

    // 更多工具
    const toToolMore = () => {
        if (isWxMiniLogin) {
            if (isLogin) {
                props.history.push(`/doctor/tools`);
            } else {
                toLogin();
            }
        } else {
            props.history.push(`/doctor/tools`);
        }
    }

    // 跳转到项目页
    const toProject = (item: any) => {
        if (item) {
            api.getPreSignStatus({
                projectCode: item.code
            }).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    if (_data.status == 0) {
                        // 0未签署 1签署 为空的话就跳过判断
                        Modal.alert('', '当前选择的项目未签署服务协议，请签署服务协议后再进行操作。', [
                            {
                                text: '取消', onPress: () => {
                                }
                            },
                            {
                                text: '立即签署', onPress: () => {
                                    props.history.push(`/doctor/laborAgreement?code=${_data.code}`);
                                }
                            }
                        ])
                        return;
                    }
                    if (_data.auditStatus == 'REJECT') { // 'AGREE' 'RUNNING' 'REJECT'
                        Modal.alert('', '您签署的服务协议未通过审核，重新签名后方可继续使用完整功能。请您确保签名正确完整，清晰可辨认。', [
                            {
                                text: '取消', onPress: () => {
                                }
                            },
                            {
                                text: '重新签署', onPress: () => {
                                    api.toGenerateAfreshSignLaborUserAgreement(_data.code).then((res: any) => {
                                        if (res.code == 0) {
                                            const _dataCode = res.data || '';
                                            props.history.push(`/doctor/laborAgreement?code=${_dataCode}`);
                                        } else {
                                            Toast.fail(res.message || '重新签署生成新协议失败', 0.8);
                                        }
                                    })
                                }
                            }
                        ])
                        return;
                    }
                } else {
                    Toast.fail(res.message || '查询签署状态失败', 0.8);
                }
                let token = sessionStorage.getItem('token');
                let mToken: any = {};
                if (token) {
                    // 每次点击更新缓存里的roleCode
                    try {
                        mToken = JSON.parse(token);

                    } catch (error) {
                        mToken = {};
                    }
                    if (mToken.roleCode) {
                        if (mToken.roleCode != 'EDC_READ') {
                            mToken.roleCode = item.roleCode;
                        }
                        sessionStorage.setItem('token', JSON.stringify(mToken));
                        localStorage.setItem('token', JSON.stringify(mToken));
                    }
                }
                let isNewUI = mToken && mToken.tenantConfig && mToken.tenantConfig.enableNewUi;
                let isNewUIPage = item.type === 'VIDEOSOLICIT' || item.type === 'QUESTIONSURVEY'
                    || item.type === 'CASESOLICIT' || item.type === 'LISTEDSTYDY';
                if (isNewUI && isNewUIPage) {
                    props.history.push(`/videoCollect?projectCode=${item.code}&projectName=${encodeURIComponent(item.name)}&projectType=${item.type}`);
                } else {
                    props.history.push(`/home?projectCode=${item.code}&projectName=${encodeURIComponent(item.name)}&projectType=${item.type}`);
                }
            });
        }
    }

    // 回到登录页
    const toLogin = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        if (savedUrlParam) {
            let savedOriginUrlParam: any = {};
            try {
                savedOriginUrlParam = JSON.parse(savedUrlParam)
            } catch (error) {
                savedOriginUrlParam = {};
            }
            // 返回至小程序授权、游客登录页
            let _from = savedOriginUrlParam.from;
            if (_from && (_from === 'login' || _from === 'tenant' || _from === 'authGuestIndex')) {
                if (utils.isMiniProgram()) {
                    (window as any).wx.miniProgram.redirectTo({
                        url: `/pages/authGuestIndex/authGuestIndex?jumpUrlFromH5=${encodeURIComponent(`/pages/login/login`)}&fromUrlFromH5=${encodeURIComponent('/doctor/home?tab=home')}`,
                        success: function (e: any) {
                        },
                        fail: function (e: any) {
                        }
                    })
                    return;
                }
            }
        }
        props.history.replace('/login');
    }

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchTitle !== null) {
            setListReady(false);
            setCurPage(1);
            if (searchTitle) {
                delayExcute = setTimeout(() => {
                    initIntroduceSearchData();
                }, 300);
            } else {
                api.getScaleIntroduceData({
                    categoryCode: currentIntroToolTab.code === 'NEW' ? '' : currentIntroToolTab.code,
                    title: searchTitle,
                    page: 1,
                    pageSize: 5
                }).then((res: any) => {
                    if (res.code == 0) {
                        setListReady(true);
                        setCurrentScaleIntroduceList(res.data.rows);
                        setTotal(res.data.total);
                        const _isMore = (res.data.total > 5);
                        setIsMore(_isMore);
                    }
                })
            }
        }
    }, [searchTitle]);

    const initIntroduceSearchData = () => {
        if (searchTitle) {
            api.getScaleIntroduceData({
                // categoryCode: searchTitle,
                title: searchTitle,
                page: 1,
                pageSize: 10
            }).then((res: any) => {
                if (res.code == 0) {
                    setListReady(true);
                    setCurrentScaleIntroduceList(res.data.rows);
                    setTotal(res.data.total)
                    const _isMore = (res.data.total > 5);
                    setIsMore(_isMore);
                }
            })
        }
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchTitle(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchTitle('');
    }

    const toolIntroduceClick = (index: any, tab: any) => {
        setCurrentIntroToolTab(tab);
        setCurPage(1);
        setTabPage(index);
        setListReady(false);
        api.getScaleIntroduceData({
            categoryCode: tab.code === 'NEW' ? '' : tab.code,
            page: 1,
            pageSize: 5,
        }).then((res: any) => {
            if (res.code == 0) {
                setCurrentScaleIntroduceList((res.data && res.data.rows) || []);
                setListReady(true);
                const _isMore = (res.data.total > 5);
                setIsMore(_isMore);
            }
        })
    }

    const toHomeScaleDetail = (val: any) => {
        props.history.push(`/doctor/homeScale?scaleCode=${val.scaleCode}`);
    }

    const activityRender = () => {
        return (
            (activityDataReady && (imgList && imgList.length > 0)) ?
                <div className={`${styles.banner_wrap}`}>
                    <Swiper
                        ref={ref}
                        indicator={() => null}
                        // indicatorProps={{
                        //     color: 'white',
                        // }}
                        defaultIndex={imgList.defaultIndex !== undefined ? imgList.defaultIndex : 0}
                        // autoplay={imgList.autoplay !== undefined ? imgList.autoplay : true}
                        loop={imgList.autoplay !== undefined ? imgList.autoplay : true}
                    >
                        {items}
                    </Swiper>
                </div>
                :
                <ActivitySkeleton />
        );
    }

    const scaleRender = () => {
        return (
            (scaleDataReady && (scaleList && scaleList.length > 0)) ?
                <div className={`${styles.my_tool}`}>
                    <div className={`${styles.tool_title}`}>
                        <div className={`${styles.tool_title_name}`}>我的工具</div>
                        <div className={`${styles.tool_more}`} onClick={() => { toToolMore() }}>
                            <span>更多</span>
                            <img src={icon_more} alt="" />
                        </div>
                    </div>
                    <div className={`${styles.tool_content}`}>
                        {
                            scaleList && scaleList.map((val: any) => {
                                return (
                                    <div onClick={() => { toTool(val) }}>
                                        <img src={val.icon || tool0} alt="" />
                                        <div>
                                            {val.title}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                :
                <ScaleSkeleton />
        )
    }

    const introduceToolsRender = () => {
        const dataView = new ListView.DataSource({
            rowHasChanged: (row1: any, row2: any) => row1 !== row2,
        });

        const dataSource = dataView.cloneWithRows(currentScaleIntroduceList);

        // 下拉加载
        const onPullToRefresh = () => {
            setIsPullToRefresh(true);
            setIsMore(true);
            // 重置状态
            setListReady(false);
            setLoading(true);
            setCurPage(1);
            setListLoading(true);
            api.getScaleIntroduceData({
                categoryCode: currentIntroToolTab.code === 'NEW' ? '' : currentIntroToolTab.code,
                title: searchTitle,
                page: 1,
                pageSize: 10
            }).then((res: any) => {
                if (res.code == 0) {
                    let _list = (res.data && res.data.rows) || [];
                    if (res.code == 0) {
                        setCurrentScaleIntroduceList(_list);
                        setTotal(res.data.total);
                    }
                    setLoading(false);
                    setListReady(true);
                    setIsPullToRefresh(false);
                    setListLoading(false);
                }
            })
        }

        // 触底上拉刷新
        const onEndListAdded = () => {
            setListReady(false);
            setListLoading(true);
            let nowPage = curPage;
            if (total > 5 && total <= 10) {
                // 第一次分页为5后面为10
                if (total > currentScaleIntroduceList.length) {
                    setIsMore(true);
                } else {
                    // 没有更多
                    setIsMore(false);
                    setListLoading(false);
                    return;
                }
            } else if (nowPage * curPageSize > total) {
                // 超出分页总数据后不再加载
                setIsMore(false);
                setListLoading(false);
                return;
            } else {
                setIsMore(true);
            }
            // 小于五条扩展至于十条此时nowPage仍为1
            if (currentScaleIntroduceList.length > 5) {
                nowPage++;
            }
            setCurPage(nowPage);
            api.getScaleIntroduceData({
                categoryCode: searchTitle ? '' : currentIntroToolTab.code === 'NEW' ? '' : currentIntroToolTab.code,
                title: searchTitle,
                page: nowPage,
                pageSize: 10
            }).then((res: any) => {
                setTimeout(() => {
                    setListLoading(false);
                    if (res.code == 0) {
                        // 小于五条扩展至于十条
                        if (currentScaleIntroduceList.length <= 5) {
                            setCurrentScaleIntroduceList(res.data.rows || []);
                        } else {
                            setCurrentScaleIntroduceList(currentScaleIntroduceList.concat(res.data && res.data.rows) || []);
                        }
                        setTotal(res.data.total);
                    }
                    setListReady(true);
                    setIsPullToRefresh(false);
                }, 375);
            });
        }

        // 上拉触底
        const onEndReached = () => {
            if (isMore) {
                //加载数据
                onEndListAdded()
            }
        }

        const row = (val: any, index: any) => (
            <div className={`${styles.tool_introduce_item}`} onClick={() => { toHomeScaleDetail(val) }}>
                {/* <img className={`${styles.tool_introduce_item_img}`} src={val.icon} alt="" /> */}
                <div className={`${styles.tool_introduce_item_content}`}>
                    <div className={`${styles.tool_introduce_item_head}`}>{val.title}</div>
                    <div className={`${styles.tool_introduce_item_bottom}`}>
                        <div className={`${val.categoryName === '量表' ? styles.tool_introduce_item_bottom_name1 : styles.tool_introduce_item_bottom_name11}`}>{val.categoryName}</div>
                        <div className={`${styles.tool_introduce_item_bottom_date}`}>{val.createTime}</div>
                        <img className={`${styles.tool_introduce_item_img_right}`} src={val.icon} alt="" />
                    </div>
                </div>
            </div>
        );
        // 少一条减去 69.3px -> 1.84799rem
        // 少一条减去 69.3px + 10px -> 2.11466rem

        // 最少保证3条
        const _listView =
            <ListView
                // 五条 10.84rem 底部加载更多 导航1.16rem
                // style={{ height: searchTitle ? '13.21rem' : '12.05rem' }}
                style={{
                    height:
                        // initScaleIntroduceNum >= 5 ? (searchTitle ? '12.63946rem' : '9.63147rem') :
                        initScaleIntroduceNum === 5 ? (searchTitle ? '12.63946rem' : '11.47946rem') :
                            initScaleIntroduceNum === 4 ? (searchTitle ? '10.52479rem' : '9.36479rem') :
                                (searchTitle ? '8.410139rem' : '7.250139rem')
                }}
                // style={{ height: searchTitle ? '10.79147rem' : '11.47946rem' }}
                // style={{ height: searchTitle ? '8.94348rem' : '7.78348rem' }}
                // style={{ height: '440px' }}
                className={styles.listview}
                dataSource={dataSource}
                renderRow={row}
                initialListSize={2000}
                onEndReached={onEndReached}
                onEndReachedThreshold={6}
                scrollRenderAheadDistance={500}
                scrollEventThrottle={200}
                useBodyScroll={false}
                // pullToRefresh={
                //     <PullToRefresh
                //         damping={60}
                //         distanceToRefresh={25}
                //         indicator={{}}
                //         direction="down"
                //         refreshing={isPullToRefresh}
                //         getScrollContainer={() => undefined}
                //         onRefresh={() => {
                //             onPullToRefresh()
                //         }}
                //     >
                //     </PullToRefresh>
                // }
                renderFooter={() => (
                    <div style={{ textAlign: 'center' }} onClick={() => { onEndReached() }}>
                        {listLoading ? '正在加载...' : isMore ? '查看更多' : '暂无更多'}
                    </div>)}
            />;

        return (
            introduceToolsReady ?
                <div className={`${styles.tool_introduce}`}>
                    <div className={`${styles.tool_introduce_head}`}>
                        <div className={`${styles.tool_introduce_head_text}`}>工具介绍</div>
                        <div className={styles.search_head}>
                            <div className={styles.search}>
                                <img className={styles.search_img} src={icon_green_search} alt="" />
                                <input type="text" placeholder="输入工具名称进行搜索" value={searchTitle} onChange={(event) => { titleInput(event) }} />
                                {
                                    searchTitle &&
                                    <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={() => { clearInput() }} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.tool_introduce_content}`}>
                    </div>
                    {
                        searchTitle &&
                        // <div className={`${styles.tool_introduce_recently} ${styles.tool_introduce_recently_with_search}`}>
                        <div className={`${styles.tool_introduce_recently}  ${initScaleIntroduceNum === 5 ? styles.tool_introduce_recently_with_search_5 :
                            initScaleIntroduceNum === 4 ? styles.tool_introduce_recently_with_search_4 : styles.tool_introduce_recently_with_search_3}`}>
                            {
                                (currentScaleIntroduceList && currentScaleIntroduceList.length > 0) &&
                                _listView
                            }
                            {
                                listReady && currentScaleIntroduceList && currentScaleIntroduceList.length == 0 &&
                                <div className={`${styles.introduce_tool_no_content} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_item_height_search_5 :
                                    initScaleIntroduceNum === 4 ? styles.tool_introduce_item_height_search_4 : styles.tool_introduce_item_height_search_3}`}>
                                    <img src={searchTitle ? introduce_tools_search_no_result : introduce_tool_no_content} alt="" />
                                </div>
                            }
                        </div>
                    }
                    {
                        !searchTitle &&
                        <Tabs tabs={introduceToolTabs}
                            initialPage={0}
                            page={tabPage}
                            swipeable={false}
                            onTabClick={(tab, index) => { toolIntroduceClick(index, tab); }}
                            tabBarUnderlineStyle={{ display: 'none' }}
                        >
                            <div className={`${styles.tool_introduce_recently} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_recently_wrap_5 :
                                initScaleIntroduceNum === 4 ? styles.tool_introduce_recently_wrap_4 : styles.tool_introduce_recently_wrap_3}`}>
                                {
                                    (currentScaleIntroduceList && currentScaleIntroduceList.length > 0) &&
                                    _listView
                                }
                                {
                                    listReady && currentScaleIntroduceList && currentScaleIntroduceList.length == 0 &&
                                    <div className={`${styles.introduce_tool_no_content} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_item_height_5 :
                                        initScaleIntroduceNum === 4 ? styles.tool_introduce_item_height_4 : styles.tool_introduce_item_height_3}`}>
                                        <img src={searchTitle ? introduce_tools_search_no_result : introduce_tool_no_content} alt="" />
                                    </div>
                                }
                            </div>
                            <div className={`${styles.tool_introduce_recently} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_recently_wrap_5 :
                                initScaleIntroduceNum === 4 ? styles.tool_introduce_recently_wrap_4 : styles.tool_introduce_recently_wrap_3}`}>
                                {
                                    (currentScaleIntroduceList && currentScaleIntroduceList.length > 0) &&
                                    _listView
                                }
                                {
                                    listReady && currentScaleIntroduceList && currentScaleIntroduceList.length == 0 &&
                                    <div className={`${styles.introduce_tool_no_content} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_item_height_5 :
                                        initScaleIntroduceNum === 4 ? styles.tool_introduce_item_height_4 : styles.tool_introduce_item_height_3}`}>
                                        <img src={searchTitle ? introduce_tools_search_no_result : introduce_tool_no_content} alt="" />
                                    </div>
                                }
                            </div>
                            <div className={`${styles.tool_introduce_recently} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_recently_wrap_5 :
                                initScaleIntroduceNum === 4 ? styles.tool_introduce_recently_wrap_4 : styles.tool_introduce_recently_wrap_3}`}>
                                {
                                    (currentScaleIntroduceList && currentScaleIntroduceList.length > 0) &&
                                    _listView
                                }
                                {
                                    listReady && currentScaleIntroduceList && currentScaleIntroduceList.length == 0 &&
                                    <div className={`${styles.introduce_tool_no_content} ${initScaleIntroduceNum === 5 ? styles.tool_introduce_item_height_5 :
                                        initScaleIntroduceNum === 4 ? styles.tool_introduce_item_height_4 : styles.tool_introduce_item_height_3}`}>
                                        <img src={searchTitle ? introduce_tools_search_no_result : introduce_tool_no_content} alt="" />
                                    </div>
                                }
                            </div>
                        </Tabs>
                    }
                </div>
                : null
        )
    }

    const projectRender = () => {
        return (
            projectDataReady ?
                <div className={`${styles.my_project}`}>
                    <div className={`${styles.project_title}`}>
                        我的项目
                    </div>
                    {
                        mergeProjects && mergeProjects.map((val: any, index: number) => {
                            // 最后一排只有一列就占据整个一行
                            // if ((index === (mergeProjects.length - 1)) && ((index + 1) % 2) === 0) {
                            if (!val[1]) {
                                return (
                                    <div key={index} className={`${styles.project_item_single} ${styles.project_item_single2} ${(index * 2) % 3 === 0 ? styles.bg_green : (index * 2) % 3 === 1 ? styles.bg_purple : styles.bg_yellow}`}
                                        onClick={() => { toProject(val[0]) }}
                                    >
                                        <div className={`${styles.project_item_info_top}`}>
                                            <span>{val[0].name}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_middle}`}>
                                            <span>目标数</span>
                                            <span>{val[0].goalNum === null ? '不限' : val[0].goalNum}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_bottom}`}>
                                            <span>完成数</span>
                                            <span>{val[0].finnishNum}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_bottom2}`}>
                                            <span>剩余数</span>
                                            <span>{val[0].goalNum === null ? '不限' : (val[0].goalNum - val[0].finnishNum)}</span>
                                        </div>
                                        <img className={`${styles.img_rb}`} src={getDisplayPicture(val[0].type, (index * 2))} alt="" />
                                    </div>
                                )
                            }
                            // 一行两列
                            return (
                                <div key={index} className={`${styles.project_item_double} ${styles.project_item_double2}`} >
                                    <div onClick={() => { toProject(val[0]) }} className={`${styles.project_item_double_item} ${(index * 2) % 3 === 0 ? styles.bg_green : (index * 2) % 3 === 1 ? styles.bg_purple : styles.bg_yellow}`}>
                                        <div className={`${styles.project_item_info_top}`}>
                                            <span>{val[0].name}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_middle}`}>
                                            <span>目标数</span>
                                            <span>{val[0].goalNum === null ? '不限' : val[0].goalNum}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_bottom}`}>
                                            <span>完成数</span>
                                            <span>{val[0].finnishNum}</span>
                                        </div>
                                        <div className={`${styles.project_item_info_bottom2}`}>
                                            <span>剩余数</span>
                                            <span>{val[0].goalNum === null ? '不限' : (val[0].goalNum - val[0].finnishNum)}</span>
                                        </div>
                                        <img className={`${styles.img_rb}`} src={getDisplayPicture(val[0].type, (index * 2))} alt="" />
                                    </div>
                                    {
                                        val[1] &&
                                        <>
                                            <div className={`${styles.project_item_double_middle}`} ></div>
                                            <div onClick={() => { toProject(val[1]) }} className={`${styles.project_item_double_item} ${(index * 2 + 1) % 3 === 0 ? styles.bg_green : (index * 2 + 1) % 3 === 1 ? styles.bg_purple : styles.bg_yellow}`}>
                                                <div className={`${styles.project_item_info_top}`}>
                                                    <span>{val[1].name}</span>
                                                </div>
                                                <div className={`${styles.project_item_info_middle}`}>
                                                    <span>目标数</span>
                                                    <span>{val[1].goalNum === null ? '不限' : val[1].goalNum}</span>
                                                </div>
                                                <div className={`${styles.project_item_info_bottom}`}>
                                                    <span>完成数</span>
                                                    <span>{val[1].finnishNum}</span>
                                                </div>
                                                <div className={`${styles.project_item_info_bottom2}`}>
                                                    <span>剩余数</span>
                                                    <span>{val[1].goalNum === null ? '不限' : (val[1].goalNum - val[1].finnishNum)}</span>
                                                </div>
                                                <img className={`${styles.img_rb}`} src={getDisplayPicture(val[1].type, (index * 2) + 1)} alt="" />
                                            </div>
                                        </>
                                    }

                                </div>
                            )
                        })
                    }
                    {/* {
                    mergeProjects.length > 0 &&
                    <div className={`${styles.project_no_more}`}>
                        — 暂无更多项目 —
                    </div>
                } */}
                    {
                        !isLogin && projectDataReady && mergeProjects.length == 0 &&
                        <div className={`${styles.no_login_register}`}>
                            <img src={NeedLoginRegister} alt="" />
                            <div className={`${styles.no_login_tip1}`}>您还未登录或注册</div>
                            <div className={`${styles.no_login_tip2}`} >注册成为用户并登录后才能查看所有项目列表</div>
                            <Button className={`${styles.no_login_button}`} color='primary' onClick={() => { toLogin() }}>立即登录或注册</Button>
                        </div>
                    }
                    {
                        isLogin && projectDataReady && mergeProjects.length == 0 &&
                        <div className={`${styles.no_project_need_add}`}>
                            <img src={NeedAddProject} alt="" />
                        </div>
                    }
                </div>
                :
                <ProjectSkeleton />
        );
    }

    return (
        <div className={`${styles.doctor_home_content}`}>
            {/* <Notice /> */}
            {
                renderList && (renderList || []).map((val: any) => {
                    if (val.type === 'Activity') {
                        return (activityRender());
                    } else if (val.type === 'Scale') {
                        return scaleRender();
                    } else if (val.type === 'ScaleIntroduce') {
                        return introduceToolsRender();
                    } else if (val.type === 'Project') {
                        return projectRender();
                    } else {
                        return null;
                    }
                })
            }
        </div>
    )
}

export default withRouter(Home);
